import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/products/sealed/$id")({
	component: SealedProductLayout,
})

function SealedProductLayout() {
	return <Outlet />
}
